module.exports = __webpack_public_path__ + "img/Jubari.b157e4d2.webp";